import { Container, Paper } from '@mui/material';
import { PropsWithChildren } from 'react';
import { HeaderPublic } from '../header';

export function PublicLayout({ children }: PropsWithChildren<{}>) {
  return (
    <div>
      <HeaderPublic />
      <Container sx={{ mt: 3.5 }} maxWidth={false}>
        <Paper>{children}</Paper>
      </Container>
    </div>
  );
}
